import type { BoggleResolvedChallengeBonus } from '~/boggle/config/challenges/modTypes'
import type { BoggleChallengeBonusId, BoggleBonusValue } from '~/boggle/config/bonuses/types'
import type { BoggleChallengeBonusDefinition } from '~/boggle/config/bonuses/bonusDefinition'
import { resolveAnchorLetterBonus } from '~/boggle/config/bonuses/definitions/anchorLetter'
import { resolveDoubleLetterBonus } from '~/boggle/config/bonuses/definitions/doubleLetter'
import { resolveNoRepeatsBonus } from '~/boggle/config/bonuses/definitions/noRepeats'
import { resolveVowelScarcityBonus } from '~/boggle/config/bonuses/definitions/vowelScarcity'
import { resolvePalindromeBonus } from '~/boggle/config/bonuses/definitions/palindrome'
import { resolveWordLengthBonus } from '~/boggle/config/bonuses/definitions/wordLengthBonus'
import type { BoggleChallengeBonusResolverContext } from '~/boggle/lib/challenge/resolveModFamily'

export type BoggleBonusResolver = (
  family: BoggleChallengeBonusDefinition,
  rngState: number,
  context: BoggleChallengeBonusResolverContext,
  value: BoggleBonusValue,
) => {
  mod: BoggleResolvedChallengeBonus
  rngState: number
} | null

export const BONUS_RESOLVERS = {
  'anchor-letter': resolveAnchorLetterBonus,
  'double-letter': resolveDoubleLetterBonus,
  longshot: resolveWordLengthBonus,
  'no-repeats': resolveNoRepeatsBonus,
  palindrome: resolvePalindromeBonus,
  shotgun: resolveWordLengthBonus,
  'vowel-scarcity': resolveVowelScarcityBonus,
} satisfies Record<BoggleChallengeBonusId, BoggleBonusResolver>
